import React, { useState } from "react";
import "./pcdoStyles.scss";
import { getParsedLocalStorage } from "../../Utils/storage-utils";
import Sidebar from "./Components/Sidebar/Sidebar";
import { AnnexureWrapper } from "./Components/Annexure/Annexure";

const dumm_ann_list = [
    {
        "id": 1,
        "code": "T1",
        "label": "T1",
        "description": "T1",
        "is_derived": true,
        "order": 11,
        "derived_from": "DIVISION"
    },
    {
        "id": 2,
        "code": "T2",
        "label": "T2",
        "description": "T2",
        "is_derived": true,
        "order": 12,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
    {
        "id": 3,
        "code": "T3",
        "label": "T3",
        "description": "T3",
        "is_derived": true,
        "order": 13,
        "derived_from": "DIVISION"
    },
]

const createAnnexureSidebarRoutes = (annexureList) => {
    if (!annexureList || annexureList.length === 0) return [];
    let sidebarRoutes = annexureList.map((annexure) => {
        const routObj = {
            id: annexure.id,
            key: annexure.code,
            shortDes: annexure.code,
            longDes: annexure.label,
            // url: `/annexure/${annexure.code}`,
        };
        return routObj;
    });
    const defaultRoutes = [];
    sidebarRoutes = [...sidebarRoutes, ...defaultRoutes];
    return sidebarRoutes;
};

function PcdoComponent() {
    const pcdo_annexure_list = getParsedLocalStorage("pcdo_annexure_list");
    const sidebarRoutes = createAnnexureSidebarRoutes(pcdo_annexure_list);

    const [selectedSidebarKey, setSelectedSideBarKey] = useState(sidebarRoutes[0].key);



    return (
        <div className="pcdo-component">
            <Sidebar
                sidebarRoutes={sidebarRoutes}
                selectedSidebarKey={selectedSidebarKey}
                handleSidebarItemClick={(key) => {
                    setSelectedSideBarKey(key)
                    localStorage.setItem('selectedSidebarKey', key)
                }}
            />
            <AnnexureWrapper annexureCode={selectedSidebarKey} />
        </div>
    );
}

export default PcdoComponent;
